// import React from 'react';

// const Webabout = () => {
//   return (
//     <div style={styles.container}>
//       <div style={styles.header}>
//         <h1 style={styles.title}>Crafting Exceptional Web Experiences</h1>
//         <p style={styles.description}>
//          From concept to launch, we build websites that elevate your business
//         </p>
//       </div>

//       <div style={styles.content}>
//         <div style={styles.image}>
//           <img src="/image/web-design-development-blog-2.jpg" alt="AI Model" style={styles.img} />
//         </div>
//       </div>

//       <style jsx>{`
//         @media screen and (max-width: 768px) {
//           .title {
//             font-size: 28px;
//           }
//           .description {
//             font-size: 16px;
//           }
//         }

//         @media screen and (max-width: 480px) {
//           .title {
//             font-size: 24px;
//           }
//           .description {
//             font-size: 14px;
//           }

//           .content {
//             flex-direction: column;
//             text-align: center;
//           }

//           .img {
//             width: 100%;
//           }
//         }
//       `}</style>
//     </div>
//   );
// };

// const styles = {
//   container: {
//     fontFamily: 'Arial, sans-serif',
//     backgroundColor: '#fff',
//     padding: '20px',
//     boxSizing: 'border-box',
//     // marginTop:'20px',
//   },
//   header: {
//     textAlign: 'center',
//   },
//   title: {
//     fontSize: '28px',
//     fontWeight: 'bold',
//     marginBottom: '20px',
//     color:'black',
//       letterSpacing: '0',

//   },
//   description: {
//     fontSize: '16px',
//     color: 'black',
//   },
//   content: {
//     display: 'flex',
//     justifyContent: 'center',
//     alignItems: 'center',
//     marginTop: '40px',
//   },
//   image: {
//     display: 'flex',
//     justifyContent: 'center',
//     height:'400px',
//     width:'100%',
//   },
//   img: {
//     maxWidth: '80%',
//     height: 'auto',
//     borderRadius: '8px',
//     boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
//   },
// };

// export default Webabout;

import React, { useState } from "react";
import { motion } from "framer-motion";
import PersonImage from "../img/aaaservices/web-ds.jpg"; // Update the path

const BusinessPromo = () => {
  const [showPopup, setShowPopup] = useState(false);

  const togglePopup = () => {
    setShowPopup(!showPopup);
  };

  return (
    <>
      <style>{`
        .containerss {
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: space-between;
          padding: 50px;
          font-family: Arial, sans-serif;
          height: auto;
        //   margin-top:30px;
          background-color:white;
          overflow: hidden;
          flex-wrap: wrap;
        }

        .text-sectiony {
          max-width: 50%;
          text-align: left;
        }

        .image-sectiony {
          display: flex;
          justify-content: flex-start;
          width: 50%;
        }

        .imagess {
          width: 100%;
          max-width: 681px;
          border-radius: 10px;
        }

        .headingyss {
          font-size: 36px;
          font-weight: bold;
          color: #0e7f9d;
          text-align:left;
        }

        .bold {
          color: #ffe124;
        }

        .highlighted {
          color: #0e7f9d;
          border-bottom: 3px solid #ffe124;
          display: inline-block;
          text-align:left;
        }

        .paragraph {
          font-size: 17px;
          color: black;
          margin: 10px 0 20px;
          text-align:left;
          font-family: 'Poppins', sans-serif;
        }

        .buttonContainer {
          margin-top: 20px;
        }

        .downloadBtn {
          background-color: #ffe124;
          color: #2a0947;
          padding: 12px 25px;
          font-size: 20px;
          border: none;
          border-radius: 8px;
          cursor: pointer;
          transition: 0.3s ease;
          font-weight: bold;
        }

        .popupOverlay {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(0, 0, 0, 0.5);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 1000;
        }

        .popupInner {
          background: white;
          padding: 30px;
          border-radius: 10px;
          text-align: center;
          position: relative;
          max-width: 400px;
          animation: slideUp 0.4s ease;
        }

        .closeBtn {
          position: absolute;
          top: 10px;
          right: 15px;
          font-size: 20px;
          background: none;
          border: none;
          cursor: pointer;
        }

        .scannerImg {
          width: 200px;
          height: auto;
          margin-bottom: 15px;
        }

        @media (max-width: 768px) {
          .containerss {
            flex-direction: column-reverse;
            height: auto;
          }

          .text-sectiony,
          .image-sectiony {
            max-width: 100%;
            width: 100%;
            text-align: center;
            justify-content: center;
          }

          .headingyss {
            font-size: 36px;
          }

          .imagess {
            max-width: 90%;
            margin: 0 auto;
          }
        }

        @media (max-width: 480px) {
          .headingyss {
            font-size: 30px;
          }

          .paragraph {
            font-size: 14px;
          }

          .downloadBtn {
            font-size: 16px;
            padding: 10px 20px;
          }

          .scannerImg {
            width: 150px;
          }
        }
      `}</style>

      <div className="containerss">
        {/* Image Section - LEFT */}

        {/* Text Section - RIGHT */}

        <motion.div
          className="image-sectiony"
          initial={{ opacity: 0, x: -50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 1, ease: "easeOut" }}
        >
          <img src={PersonImage} alt="Person" className="imagess" />
        </motion.div>

        <motion.div
          className="text-sectiony"
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, ease: "easeOut" }}
        >
          <p className="headingyss">
            Web Development <span className="bold">Solutions</span> <br />
            {/* <span className="bold"></span>  <br /> */}
          </p>

          <p className="paragraph">
            We ensure that your website not only looks visually appealing but
            also functions intuitively to engage and retain visitors. By
            utilizing the latest technologies and best practices, we build a
            scalable and secure websites that can evolve alongside your
            business.
          </p>
          <p className="paragraph">
            Our services encompass everything from initial concept and design to
            development, testing, and deployment, guaranteeing a robust and
            functional final product. With a focus on user interface (UI) and
            user experience (UX) design.
          </p>
          <p className="paragraph">
            We are committed to delivering high-quality websites that reflect
            your brand identity and drive conversions. We provide ongoing
            maintenance and support to keep your website updated and running
            smoothly.
          </p>
        </motion.div>
      </div>
    </>
  );
};

export default BusinessPromo;
